import { getMembershipCashbackRate } from "../data/membershipPlans";

export const MANDATORY_VISITATION_FEE = 99;

export function generateServiceDates(days = 7) {
  const result = [];
  const today = new Date();

  for (let i = 0; i < days; i += 1) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);

    result.push({
      value: d.toISOString().split("T")[0],
      label: d.toLocaleDateString("en-IN", {
        weekday: "short",
        day: "numeric",
        month: "short",
      }),
      isToday: i === 0,
      isTomorrow: i === 1,
    });
  }

  return result;
}

export function generateHalfHourSlots() {
  const slots = [];
  const startHour = 6;
  const endHour = 18;

  for (let hour = startHour; hour <= endHour; hour += 1) {
    const minuteOptions = hour === endHour ? [0] : [0, 30];

    for (const minute of minuteOptions) {
      const date = new Date();
      date.setHours(hour, minute, 0, 0);

      const formatted = date.toLocaleTimeString("en-IN", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

      let availabilityLabel = "available";

      if (hour >= 17) {
        availabilityLabel = "filling_fast";
      }

      if (hour === 18 && minute === 0) {
        availabilityLabel = "filling_fast";
      }

      slots.push({
        value: `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`,
        label: formatted,
        status: availabilityLabel,
      });
    }
  }

  return slots;
}

export function getMaterialDeliveryEstimate({
  quantity = 1,
  priorityDelivery = false,
  distanceKm = 5,
  vehicleType = "bike",
}) {
  let baseHours = 4;

  if (vehicleType === "mini_truck") baseHours = 8;
  if (vehicleType === "truck") baseHours = 12;
  if (distanceKm > 10) baseHours += 4;
  if (quantity > 20) baseHours += 4;
  if (priorityDelivery) baseHours = Math.max(2, baseHours - 2);

  if (baseHours <= 4) return "Estimated delivery in 2 to 4 hours";
  if (baseHours <= 8) return "Estimated delivery today";
  if (baseHours <= 16) return "Estimated delivery by tomorrow";
  return "Estimated delivery in 1 to 2 days";
}

export function calculateMaterialDeliveryCharge(item, priorityDelivery = false) {
  const quantity = Number(item.quantity || 1);
  const distanceKm = Number(item.distanceKm || 5);
  const vehicleType = item.vehicleType || "bike";

  let baseCharge = 49;

  if (vehicleType === "auto") baseCharge = 99;
  if (vehicleType === "mini_truck") baseCharge = 249;
  if (vehicleType === "truck") baseCharge = 599;

  const distanceCharge = Math.round(distanceKm * 6);
  const quantityLoadCharge = Math.round(quantity * 4);
  const priorityCharge = priorityDelivery ? 79 : 0;

  return baseCharge + distanceCharge + quantityLoadCharge + priorityCharge;
}

export function calculateCheckoutSummary({
  serviceItems,
  materialItems,
  membership,
  priorityDelivery,
}) {
  const serviceSubtotal = serviceItems.reduce(
    (sum, item) => sum + Number(item.finalPrice || 0),
    0
  );

  const visitationFee = serviceItems.reduce((sum, item) => {
    const quantity = Number(item.quantity || 1);
    const unitPrice = Number(item.basePrice || item.finalPrice || 0);

    if (unitPrice < 300) {
      return sum + MANDATORY_VISITATION_FEE * quantity;
    }

    return sum;
  }, 0);

  const materialSubtotal = materialItems.reduce(
    (sum, item) => sum + Number(item.finalPrice || 0),
    0
  );

  const serviceFee = Math.round(serviceSubtotal * 0.08);
  const platformFee = Math.round((serviceSubtotal + materialSubtotal) * 0.04);

  const deliveryCharge = materialItems.reduce(
    (sum, item) => sum + calculateMaterialDeliveryCharge(item, priorityDelivery),
    0
  );

  const tax = Math.round((serviceFee + platformFee) * 0.18);
  const subtotalBeforeMembership =
    serviceSubtotal +
    materialSubtotal +
    visitationFee +
    serviceFee +
    platformFee +
    deliveryCharge +
    tax;
  const membershipPrice = membership ? Number(membership.upfrontPrice || 0) : 0;
  const membershipCashback = membership
    ? Math.round(subtotalBeforeMembership * getMembershipCashbackRate())
    : 0;

  const total =
    subtotalBeforeMembership + membershipPrice;

  return {
    serviceSubtotal,
    materialSubtotal,
    visitationFee,
    serviceFee,
    platformFee,
    deliveryCharge,
    tax,
    subtotalBeforeMembership,
    membershipPrice,
    membershipCashback,
    total,
  };
}
